module.exports = __webpack_public_path__ + "static/media/icon-logout.9e6bf63c.svg";